/**
 * Website template picker types.
 *
 * The catalogue itself is NOT defined here. It is owned by the API template
 * registry and fetched through `GET /websites/templates`, so registering a new
 * template in `BW-API` is all that is needed for it to appear in the
 * "New website" modal. Do not reintroduce a hard-coded list in this app.
 */

/**
 * Template ids are API-defined. Kept as a string alias rather than a union so
 * the frontend never needs editing when a template is added.
 */
export type BuiltInWebsiteTemplateId = string;

export type BuiltInWebsiteTemplateCategory = 'Blank' | 'Presentation' | 'Commerce';

export interface BuiltInWebsiteTemplateDefinition {
  id: BuiltInWebsiteTemplateId;
  name: string;
  description: string;
  pageCount: number;
  pageLabels: string[];
  audience: string;
  highlights: string[];
  category: BuiltInWebsiteTemplateCategory;
  industry: string;
}

/** Used until the catalogue request resolves, and if it fails. */
export const FALLBACK_WEBSITE_TEMPLATE: BuiltInWebsiteTemplateDefinition = {
  id: 'blank-site',
  name: 'Blank website',
  category: 'Blank',
  industry: 'Flexible',
  description: 'Start with one clean editable home page and shape everything from scratch.',
  audience: 'Builders who already know the structure they want.',
  highlights: ['One starter page', 'Theme toggle ready', 'Maximum layout freedom'],
  pageCount: 1,
  pageLabels: ['Home']
};
